module.exports = __webpack_public_path__ + "static/media/Class.d262cdd9.m4v";